// portalRoot — where portaled UI (modals, dialogs, dropdown menus) should
// mount. Normally document.body, BUT: the dispatch board fullscreens its
// own div via element.requestFullscreen(), and in element-fullscreen the
// browser renders ONLY that element's descendants. Anything portaled to
// document.body — AssignModal, JobModal, every ConfirmDialog, dropdown
// menus — was invisible until fullscreen exited (Jaylen 2026-07-09:
// "crew/truck assignments don't display in fullscreen").
//
// Mounting into document.fullscreenElement when one is active keeps all
// portaled UI visible in both modes. position:fixed children keep working
// — the fullscreen element IS the viewport.
export const portalRoot = () =>
  (typeof document !== 'undefined' && document.fullscreenElement) || document.body
